export const sweetpass = {
  'sweetpass-plus': 'Sweetpass+',

  // ─── SIGNED OUT ──────────────────────────────────────────────────

  'sweetpass.sign-out.text':
    'Sign in to see all your challenges and get special rewards ',
  'sweetpass.sign-out.sign-in-or-join': 'Sign in or join',

  // ─── SIGNED IN ───────────────────────────────────────────────────

  'sweetpass.signed-in.header': 'sweetpass',
  'sweetpass.signed-in.sweetpass+.text': 'Review and purchase Sweetpass+',
  'sweetpass.signed-in.payment-method': '{type} ending in {lastFour}',
  'sweetpass.signed-in.sweetpass+.agreement':
    'By checking this box and clicking "Upgrade to Sweetpass+", you authorize sweetgreen to charge your designated payment method $10.00 today (plus any applicable tax), on [date of purchase], and every month after. You can cancel any time in the “Sweetpass membership” section of your Account tab or by emailing xx@sweetgreen.com. To avoid being charged for another subscription period, cancel at least 48 hours before your next subscription period starts.',
  'sweetpass.signed-in.add-payment-method': 'Add payment method',
  'sweetpass.signed-in.add-payment-method-title': 'Add card for Sweetpass+',
  'sweetpass.signed-in.credit-card': 'Credit or debit card',
  'sweetpass.signed-in.paypal': 'PayPal',
  'sweetpass.signed-in.apple-pay': 'Apple Pay',
  'sweetpass.signed-in.venmo': 'Venmo',

  // ───–––––––––––───────────────────────────────────────────────────

  // ─── SWEETPASS JOIN ──────────────────────────────────────────────

  'sweetpass-join.title': 'Join sweetpass',

  // ─── SWEETPASS CELEBRATION ───────────────────────────────────────

  'sweetpass-celebration.title': 'WELCOME TO SWEETPASS+',
  'sweetpass-celebration.subtitle': 'READY TO WATCH YOUR GREENS GROW?',
  'sweetpass-celebration.button-text': 'Explore Sweetpass+',

  // ───–––––––––––───────────────────────────────────────────────────

  // ─── SWEETPASS UPGRADE ───────────────────────────────────────────

  'sweetpass-upgrade.title': 'Upgrade to Sweetpass+',
  'sweetpass-upgrade.confirm-modal.button': 'Join sweetpass',
  'sweetpass-upgrade.confirm-modal':
    'By joining sweetpass you agree to {terms}. Opt out at any time by reaching out to our CX team at {email}.',
  'sweetpass-upgrade.confirm-modal.terms': 'sweetgreen’s terms and conditions',
  'sweetpass-upgrade.confirm-modal.terms-url':
    'https://www.sweetgreen.com/terms',
  'sweetpass-upgrade.confirm-modal.email': 'hello@sweetgreen.com',
  'sweetpass-upgrade.confirm-modal.email-url': 'mailto:hello@sweetgreen.com',

  // ───–––––––––––───────────────────────────────────────────────────

  // ─── SWEETPASS CHECK OUT ─────────────────────────────────────────
  'sweetpass.checkout.header': 'Review and purchase Sweetpass+',
  'sweetpass.checkout.upgrade-cta': 'Upgrade to Sweetpass+',
  'sweetpass.checkout.credit-card.description':
    '{cardType} ending in {lastFour}',
  'sweetpass.checkout.credit-card.new': 'Add payment method',
  'sweetpass.checkout.credit-card.replace': 'Replace',
  'sweetpass.checkout.upgrade-cta-notice':
    'By clicking “Upgrade to Sweetpass+”, you also agree to our {terms}.',
  'sweetpass.checkout.upgrade-cta-notice.terms-description':
    'terms and conditions',
  'sweetpass.checkout.join-sweetpass-plus.notice.failure':
    'Sorry something went wrong with creating your subscription, please try again in a few minutes',

  // ───–––––––––––───────────────────────────────────────────────────

  // ─── SWEETPASS PAYMENT METHODS ─────────────────────────────────────────

  'sweetpass.credit-card-form.edit': 'Edit card',
  'sweetpass.credit-card-form.add': 'Add card',

  // ───–––––––––––───────────────────────────────────────────────────

  // ─── SWEETPASS HOME PAGE ─────────────────────────────────────────
  'sweetpass.home.header-name': '{firstName}’s ',
  'sweetpass.home.header-membership': '{membership}',
  'sweetpass.home.header-tier-illustration': '"{tierName}" tier illustration',
  'sweetpass.home.stats.member-since': 'Member since {sweetpass_join_date}',
  'sweetpass.home.stats.detailed.saved': '{amount} saved',
  'sweetpass.home.stats.reward': 'Reward\navailable',
  'sweetpass.home.stats.rewards': 'Rewards\navailable',
  'sweetpass.home.stats.challenge': 'Challenge\navailable',
  'sweetpass.home.stats.challenges': 'Challenges\navailable',
  'sweetpass.home.stats.cta': 'Explore your benefits',
  'sweetpass.home.rewards-rail.deadline-prefix': 'Use by',
  'sweetpass.home.challenges-rail.deadline-prefix': 'Ends',
  'sweetpass.home.challenges-rail.completion-text': 'Challenge completed',
  'sweetpass.home.challenges-rail.new-badge': 'New',

  // ───–––––––––––───────────────────────────────────────────────────

  // ─── SWEETPASS ERRORS ─────────────────────────────────────────
  'sweetpass.payment-method.duplicate':
    "We couldn't add your card because that card already exists in your account",
  'sweetpass.subscription.cannot-reactivate':
    'This subscription cannot be rejoined because it is already canceled',
};
